import React from 'react';

class ModalFooter extends React.PureComponent {
    render() {
        return <div className="m2g-modal-footer">{this.props.children}</div>;
    }
}

ModalFooter.Left = props => (
    <div className="m2g-modal-footer-left">{props.children}</div>
);
ModalFooter.Right = props => (
    <div className="m2g-modal-footer-right">{props.children}</div>
);

export default ModalFooter;
